import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { PLAN_PRO } from '../../../constants/userSubscriptionPlans'
import { ROLE_TYPE } from '../permissions'

export enum TABS_PERMISSION {
  CREATE = 'CREATE',
}

export const getTabsPermissionsMatrix = (): Record<
  TABS_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [TABS_PERMISSION.CREATE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.TRIAL_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
